export default {
    noEvent: 'Nessun evento trovato',
    noEventDesc: 'Per favore accedi di nuovo.',
    noLocation: 'Luogo non definito',
    guestList: 'Lista degli ospiti',
    guestListDesc: 'Vedi chi partecipa all\'evento.',
    tasks: 'Compiti',
    tasksDesc: 'Visualizza programma e compiti da fare.',
    budget: 'Budget',
    budgetDesc: 'Visualizza budget stimato.',
    welcomeTitle: 'Benvenuto nel tuo spazio ospite',
    welcomeDesc: 'Qui puoi visualizzare le informazioni sull\'evento e vedere la lista degli ospiti. Altre funzionalità arriveranno presto!'
};
